import React, { useState } from 'react';
import "./page.css";
import Travel_Img from "../assets/travel-india.png";
import { RxCross1 } from "react-icons/rx";
import RewardsIcon from "../assets/rewards-icon.png"
import ArrowLeft from "../assets/left-icon.png"
import { Link } from 'react-router-dom'

export default function Level() {
    const [selectedCard, setSelectedCard] = useState(null);

    const cardData = [
        { id: 1, title: "Trial Card", number: "No.1", commission: "1%", ratings: "30 ratings" },
        { id: 2, title: "Sapphire Card", number: "No.2", commission: "1.1%", ratings: "30 ratings" },
        { id: 3, title: "White Silver Card", number: "No.3", commission: "1.1%", ratings: "30 ratings" },
        { id: 4, title: "Gold Card", number: "No.4", commission: "1.1%", ratings: "30 ratings" },
        { id: 5, title: "Diamond Card", number: "No.5", commission: "1.1%", ratings: "30 ratings" },
        { id: 6, title: "Titanium Gold Card", number: "No.6", commission: "1.1%", ratings: "30 ratings" },
    ];

    const openPopup = (card) => {
        setSelectedCard(card);
    };

    const closePopup = () => {
        setSelectedCard(null);
    };

    return (
        <>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>

            <div className='container'>

                <div className='inner_title_section'>
                    <div className='container'>
                        <div className='inner_title_flex'>
                            <Link to='/booking'> <img src={ArrowLeft} /></Link>
                            <h3>Level</h3>
                        </div>
                    </div>
                </div>

                <div className='level_inner'>
                    {cardData.map((card) => (
                        <div key={card.id} className={`level_card level_${card.id}`} onClick={() => openPopup(card)}>
                            <img src={Travel_Img} alt="Travel India" />
                            <h2>{card.title}</h2>
                            <div className='level_box_list'>
                                <h4>{card.number}</h4>
                            </div>
                        </div>
                    ))}
                </div>

                {selectedCard && (
                    <div className="popup-overlay" onClick={closePopup}>
                        <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                            <div className="popup-header">
                                <h2>{selectedCard.title}</h2>
                                <button className="close-btn" onClick={closePopup}><RxCross1 /></button>
                            </div>
                            <div className="popup-content">
                                <div className='level_modal'><p>The commission rate is:</p><p>{selectedCard.commission}</p></div>
                                <div className='level_modal'><p>Number of ratings:</p><p>{selectedCard.ratings}</p></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
